import { Injectable } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { take } from "rxjs/operators";
import { RowState } from "../../../../../projects/sepidz-web-framework/src/lib/models/enums";
import { MapObjectPipe } from "../../../../../projects/sepidz-web-framework/src/lib/pipes/mapobject.pipe";
import { SaleMethodBranchModel } from "../../sales/model/sale-method-branch.model";
import { Salon, Table, TableRead, TableStatus } from "../../salons/model/salon.model";
import { Invoice, InvoiceStatus, InvoiceCommand, InvoiceEntry, PaymentLinkState } from "../model/invoice.model";
import { OrderService } from "../order.service";
import { InvoiceActionService } from "../providers/invoiceaction.service";
import { ActivePageEnum } from "../model/activepage.enum";

@Injectable({
  providedIn: "root",
})
export class SalonOrderService extends BaseService {
  public _salons: Salon[] = [];
  tableFilter: any[] = [
    { key: 1, title: this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Empty"), count: 0, selected: false },
    { key: 2, title: this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Order"), count: 0, selected: false },
    { key: 3, title: this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Settlement"), count: 0, selected: false },
    { key: 4, title: this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.StopTooMuch"), count: 0, selected: false },
  ];
  currentSaleMethodBranch: SaleMethodBranchModel;
  selectedSalons: Salon;
  clearAccess: boolean = false;
  printAccess: boolean = false;
  selectedTableId: number;
  _tables: Table[];
  _tableReads: TableRead[];
  _changeTable: boolean = true;
  _tempTableReads: TableRead[];
  _tableStatus: typeof TableStatus = TableStatus;

  constructor(public order: OrderService, public invoiceAction: InvoiceActionService, public common: CommonService) {
    super();
  }

  ngOnInit() {
    this.invoiceAction.ngOnInit();
    this._tables = [];
    this._tableReads = [];
    this._tempTableReads = [];
  }

  //دریافت سالن ها بر اساس نحوه فروش
  async getSalon() {
    if (
      this.order?.saleMethodBranch &&
      this.order.currentSaleMethodNature &&
      this.order.currentSaleMethodNature !== this.order.SaleMethodNature.Delivery
    ) {
      let UserId = this.accountService.authService.currentUser.Id;
      this.httpCommonService
        .getItem(`Salon/GetSalons/${UserId}`, this.order.saleMethodBranch.Id)
        .pipe(take(1))
        .subscribe((data: Salon[]) => {
          if (data && data.length > 0) {
            this._salons = this.order.salons = data.filter((f) => !f.Illegal);
            if (this.selectedSalons) this.getTablesRead(this.selectedSalons);
            else {
              const selected = this._salons.find((f) => f.Selected);
              if (selected) {
                this.selectedSalons = Object.assign({}, selected);
                this.getTablesRead(selected);
              } else this.getTablesRead(this.order.salons[0]);
            }
          } else {
            this.sts.showToast(
              "danger",
              this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Attention"),
              this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.CurrentSalesMethodDoesNotIncludeAnySalons"),
              1500
            );
          }
          this.order.detectChanges();
        });
    }
  }

  //دریافت میزها بر اساس سالن
  getTablesRead(salon: Salon) {
    if (
      (this.order.invoice.OldSaleMethodBranchId && this.order.invoice.OldTableId) ||
      (this.order.currentSaleMethodNature && this.order.currentSaleMethodNature !== this.order.SaleMethodNature.Delivery)
    ) {
      const tableRead = new TableRead();
      tableRead.SaleMethodBranchId = this.order.saleMethodBranch?.Id;
      tableRead.SalonId = salon?.Id;
      tableRead.RelativeInvoiceTime = undefined;
      tableRead.MaximumTimeForStay = this.order.saleMethodBranch.MaximumTimeForStay;
      this.httpCommonService
        .create("Salon/GetTables", tableRead)
        .pipe(take(1))
        .subscribe((data: any) => {
          this.selectedSalons = salon;
          this._tempTableReads = this._tableReads = data.sort((a, b) => a.Code - b.Code);
          this.tableFilter[0].count = this._tableReads.filter((f) => f.Status === TableStatus.Free).length;
          this.tableFilter[1].count = this._tableReads.filter((f) => f.Status === TableStatus.Ordering).length;
          this.tableFilter[2].count = this._tableReads.filter((f) => f.Status === TableStatus.Clearing).length;
          this.tableFilter[3].count = this._tableReads.filter((f) => f.Status === TableStatus.TimeOver).length;
          this.tableFilterByStatus();
          this.order.detectChanges();
          this.order.splashFormService.closeLoading();
        });
    }
  }

  //فیلتر کردن میزها بر اساس وضعیت
  tableFilterByStatus() {
    const selectedList = this.tableFilter.filter((f) => f.selected);
    this._tempTableReads = JSON.parse(JSON.stringify(this._tableReads));
    if (selectedList && selectedList.length > 0) {
      this._tempTableReads = [];
      selectedList.forEach((element) => {
        const filterItem = this._tableReads.filter((f) => f.Status === element.key);
        filterItem.forEach((ele) => {
          this._tempTableReads.push(ele);
        });
      });
    }
  }

  //نمایش اطلاعات فاکتور براساس کلیک بر روی میز
  public SelectTable(tableRead: TableRead): void {
    this.order.itemChanged = false;
    if (tableRead.Locked) return;
    this.order.shouldActivateInvoicesPage = false;
    this.order.shouldActivateSalonPage = true;
    if (this.order.invoice.TableId === tableRead?.Id) {
      this.paymentLinkValidation();
      this.order.invoice.SalonId = tableRead.SalonId;
      this.order.currentActivePage = this.common.isMobileMode
        ? this.order.invoice.Items?.length > 0
          ? this.order.activePageEnum.Invoice
          : this.order.activePageEnum.OrderItem
        : this.order.activePageEnum.Order;
      this.order.detectChanges();
    } else if (
      !(this.order.invoice.StatusCode === InvoiceStatus.New) &&
      tableRead.Status === TableStatus.Free &&
      !this.order.saleMethodBranchChanged
    ) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.LikeChangeTable")}`,
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ChangingTable"),
        DialogType.confirm,
        () => {
          this.ChangeInvoiceTable(tableRead);
          this.order.invoiceChanged = true;
          this.order.checkInvoiceState(this.order.invoice.CommandCode);
          this.order.detectChanges();
        }
      );
    } else if (this.order.invoice.StatusCode === InvoiceStatus.New && tableRead.Status === TableStatus.Free) {
      this.ChangeInvoiceTable(tableRead);
    } else if (this.order.invoice.StatusCode !== InvoiceStatus.New && tableRead.Status === TableStatus.Free && this.order.saleMethodBranchChanged) {
      this.ChangeInvoiceTable(tableRead);
      this.order.invoiceChanged = true;
      this.order.checkInvoiceState(this.order.invoice.CommandCode);
      this.order.detectChanges();
    } else if (
      (this.order.invoice.StatusCode === InvoiceStatus.New && !(tableRead.Status === TableStatus.Free)) ||
      (!(this.order.invoice.StatusCode === InvoiceStatus.New) && !(tableRead.Status === TableStatus.Free))
    ) {
      if (!this.order.invoiceChanged) {
        this.LoadInvoice(tableRead);
        this.order.detectChanges();
      } else {
        this.LoadInvoice(tableRead);
        this.order.invoiceChanged = false;
      }
    }
  }

  //تغییر میز فاکتور
  ChangeInvoiceTable(tableRead: TableRead) {
    this.order.invoice.OldTableTitle = this.order.invoice.TableTitle;
    this.order.invoice.OldTableId = this.order.invoice.TableId;
    this.order.invoice.TableId = tableRead?.Id;
    if (this.order.invoice.OldTableId)
      this.order.invoice.hasChangedTable = this.order.invoice.TableId != this.order.invoice.OldTableId ? true : false;
    else this.order.invoice.SalonId = tableRead?.Id;
    this.order.invoice.TableTitle = tableRead.Title;
    this.order.invoice.SalonId = tableRead.SalonId;
    this.order.currentActivePage = this.common.isMobileMode
      ? this.order.invoice.Items?.length > 0
        ? this.order.activePageEnum.Invoice
        : this.order.activePageEnum.OrderItem
      : this.order.activePageEnum.Order;
    this.order.detectChanges();
  }

  //دریافت اطلاعات فاکتور بر اساس آی دی فاکتور
  LoadInvoice(tableRead: TableRead) {
    this.order.itemQuantityChanged = false;
    this.order.splashScreenService.startLoading();
    this.order.splashFormService.openDialog("", " ");
    this.getInvoiceById(tableRead.InvoiceId).subscribe((data: Invoice) => {
      if (data) {
        this.order.shouldActivateSalonPage = true;
        this.order.invoice = data;
        this.paymentLinkValidation();
        let output = new InvoiceEntry();
        let mapper = new MapObjectPipe();
        this.order.invoice.OriginalValue = JSON.parse(JSON.stringify(mapper.transform(data, output)));
        this.order.invoice.OriginalValue.SaleMethodBranch = this.order.saleMethodList.find((z) => z.Id === data.SaleMethodBranchId);
        this.order.invoice.Items = JSON.parse(
          JSON.stringify(
            data.Items.sort(function (a, b) {
              return a.Index - b.Index;
            })
          )
        );
        this.order.invoice.Items = this.order.invoice.Items.filter((f) => f.State !== RowState.Delete);
        this.order.setValueformGroupControl();
        this.order.invoice.LastInvoiceCode = data.Code;
        this.order.invoice.LastInvoiceAmount = data.PayableTotal;
        this.order.invoice.State = RowState.Modify;
        this.order.splashFormService.closeLoading();
        this.ChangeInvoiceTable(tableRead);
        this.order.setInvoiceHasFactorAndHasPaymentLink();
        this.order.calculate();
        this.order.closeSidebar();
        this.order.detectChanges();
      }
    });
  }

  getInvoiceById(id: number) {
    return this.httpCommonService.getItem("Invoice/GetInvoiceById", id).pipe(take(1));
  }

  //تسویه
  ClearingInvoice(tableRead: TableRead) {
    if (
      (tableRead.InvoiceStatusCode === InvoiceStatus.Ordering &&
        !this.accountService.userHasPermission(`RestaurantSale:Invoice_${this.order.saleMethodBranch.SaleMethodId}`, "ClearOrderingStatus")) ||
      (tableRead.InvoiceStatusCode === InvoiceStatus.Clearing &&
        !this.accountService.userHasPermission(`RestaurantSale:Invoice_${this.order.saleMethodBranch.SaleMethodId}`, "ClearClearingStatus"))
    ) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.AccessToThisArea")
      );
      return;
    }
    if (tableRead.InvoiceStatusCode === InvoiceStatus.Ordering || tableRead.InvoiceStatusCode === InvoiceStatus.Clearing) {
      this.httpCommonService
        .getItem("Invoice/GetInvoiceById", tableRead.InvoiceId)
        .pipe(take(1))
        .subscribe((data: Invoice) => {
          this.order.itemQuantityChanged = false;
          this.invoiceAction.SaveInvoice(InvoiceCommand.Clear, data, true, this.order);
          this.invoiceAction.saveEnd.pipe(take(1)).subscribe((isFinish: boolean) => {
            if (isFinish) {
              this.getSalon();
              this.order.newInvoice();
            }
          });
        });
    } else {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.PossibleSettleInvoiceTemporaryState")
      );
    }
  }

  //چاپ مشتری
  CustomerPrintInvoice(tableRead: TableRead) {
    if (!this.accountService.userHasPermission(`RestaurantSale:Invoice_${this.order.saleMethodBranch.SaleMethodId}`, "CustomerPrintOrderingStatus")) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.AccessToThisArea")
      );
      return;
    }
    this.order.splashFormService.openDialog();
    this.httpCommonService
      .getItem("Invoice/GetInvoiceById", tableRead.InvoiceId)
      .pipe(take(1))
      .subscribe((data: Invoice) => {
        if (data) {
          this.order.splashFormService.closeLoading();
          this.order.itemQuantityChanged = false;
          this.invoiceAction.SaveInvoice(InvoiceCommand.CustomerPrint, data, true, this.order);
          this.invoiceAction.saveEnd.pipe(take(1)).subscribe((isFinish: boolean) => {
            if (isFinish) this.getSalon();
          });
          this.order.detectChanges();
        }
      });
  }
  trackByFn(index, item) {
    return item.Id;
  }

  retryLink(tableRead: TableRead) {
    if (!tableRead || !tableRead.InvoiceId) return;
    this.order.splashFormService.openDialog("", " ");
    this.getInvoiceById(tableRead.InvoiceId).subscribe((data: Invoice) => {
      if (!data?.PhoneNumber?.startsWith("09")) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.InvoiceNoHaveMobileNumber")}`,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage")
        );
        this.order.splashFormService.closeLoading();
        return;
      }
      if (data?.Debit === data?.PayableTotal) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.TotalAmountInvoicePlacedDebit")}`,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage")
        );
        this.order.splashFormService.closeLoading();
        return;
      }
      if (data?.Customer?.AutomaticDebtor) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.PossibleSendLinkCustomerAutomaticallyDebt")}`,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.ErrorMessage")
        );
        this.order.splashFormService.closeLoading();
        return;
      }
      this.httpCommonService
        .get(`Invoice/RetryLink/${data?.Id}`)
        .pipe(take(1))
        .subscribe(
          () => {
            this.order.splashFormService.closeLoading();
          },
          () => {
            this.order.splashFormService.closeLoading();
          }
        );
    });
  }

  private paymentLinkValidation() {
    if (typeof this.order.invoice.PaymentLinkState === "number") {
      const status = this.order.getStatusOfLinkPayment(this.order.invoice.PaymentLinkState);
      switch (status) {
        case PaymentLinkState.Paid:
          if (this.order.invoice.StatusCode == InvoiceStatus.Cleared) {
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.InvoicePaidThroughLink")}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Warning")
            );
          }
          break;

        default:
          if (this.order.saleMethodBranch.IsPaymentLink && status > PaymentLinkState.Nothing) {
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.LinkDesiredInvoiceSentCustomerInvoiceChanged")}`,
              this.translate("ClientApp.FrontOffice.Order.OrderPage.SalonOrder.Warning"),
              DialogType.confirm,
              () => {
                //بعد از تایید کاربر جهت تغییر فاکتور می بایست در سیستم لاگ ثبت گردد که کاربر بعد از ارسال لینک اقدام به تغییر فاکتور نموده است
              },
              () => {
                this.order.newInvoice();
                this.order.setActivePage(ActivePageEnum.Invoices);
              }
            );
          }
          break;
      }
    }
  }
}
